import { render, staticRenderFns } from "./ProjectEdit.vue?vue&type=template&id=0afa2a2e&scoped=true&"
import script from "./ProjectEdit.vue?vue&type=script&lang=js&"
export * from "./ProjectEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProjectEdit.vue?vue&type=style&index=0&id=0afa2a2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afa2a2e",
  null
  
)

export default component.exports